import { createContext, useContext, useState, type ReactNode } from "react";

interface FinancePostcodeContextValue {
  postcode: string;
  setPostcode: (value: string) => void;
}

const FinancePostcodeContext = createContext<FinancePostcodeContextValue | null>(null);

export function FinancePostcodeProvider({ children }: { children: ReactNode }) {
  const [postcode, setPostcode] = useState("");
  return (
    <FinancePostcodeContext.Provider value={{ postcode, setPostcode }}>
      {children}
    </FinancePostcodeContext.Provider>
  );
}

export function useFinancePostcode(): FinancePostcodeContextValue {
  const ctx = useContext(FinancePostcodeContext);
  if (!ctx) {
    throw new Error("useFinancePostcode must be used within a FinancePostcodeProvider");
  }
  return ctx;
}
